// extracted by mini-css-extract-plugin
export var explainable = "_hg-a";
export var printerCard = "_hg-1";
export var printerCardConfigured = "_hg-2";
export var printerCardError = "_hg-3";
export var printerCardsContainer = "_hg-0";
export var printerIcon = "_hg-8";
export var printerIconConfigured = "_hg-5";
export var printerIconContainer = "_hg-4";
export var printerIconError = "_hg-6";
export var printerIconUnconfigured = "_hg-7";
export var workstationsTableCard = "_hg-9";